import { Button } from "@medusajs/ui"
import type { ReactNode } from "react"
import { Link } from "react-router-dom"
import { EmptyState, PageHeader, Section } from "@/components/ui"
import { useCurrentMe } from "@/lib/permissions"
import { isAppOn } from "./registry"

/** Renders an app only while it's switched on, so a switched-off app's code is never downloaded. */
export function AppGate({ id, name, children }: { id: string; name: string; children: ReactNode }) {
  const me = useCurrentMe()
  if (isAppOn(me, id)) return <>{children}</>
  return (
    <>
      <PageHeader title={name} />
      <Section>
        <EmptyState
          title={`${name} is turned off`}
          body="Turn it on in Settings → Apps to use it again. Its data was kept."
          action={
            <Button size="small" variant="secondary" asChild>
              <Link to="/settings/apps">Open Settings → Apps</Link>
            </Button>
          }
        />
      </Section>
    </>
  )
}
